import { Link } from "react-router-dom";
import { Building2, ClipboardList, ShoppingBasket } from "lucide-react";

export default function LocationHeader({
  location,
  showBasket = false,
  basketCount = 0,
  basketTotal = 0,
  onBasketClick,
  showOrdersLink = false,
  slug,
}) {
  return (
    <header className="bg-[#1aa59a] sticky top-0 z-40 shadow-md" data-testid="location-header">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
        {location.logo_base64 ? (
          <img
            src={location.logo_base64}
            alt={location.name}
            className="w-10 h-10 rounded-lg object-cover bg-white"
          />
        ) : (
          <div className="w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center">
            <Building2 className="w-5 h-5 text-white" />
          </div>
        )}

        <div className="text-white flex-1 min-w-0">
          <h1 className="text-base sm:text-lg font-bold truncate">{location.name}</h1>
          {location.address && (
            <p className="text-xs text-white/80 truncate">{location.address}</p>
          )}
        </div>

        {showOrdersLink && slug && (
          <Link
            to={`/loc/${slug}/orders`}
            className="hidden sm:inline-flex items-center gap-1 bg-white/15 hover:bg-white/25 text-white text-xs font-semibold px-3 py-2 rounded-lg transition-colors"
            data-testid="location-orders-link"
          >
            <ClipboardList className="w-4 h-4" />
            Orders
          </Link>
        )}

        {showBasket && (
          <button
            type="button"
            onClick={onBasketClick}
            className="relative bg-white text-[#1aa59a] font-semibold rounded-lg px-3 py-2 flex items-center gap-2 hover:bg-white/90 transition-colors"
            data-testid="basket-button"
          >
            <ShoppingBasket className="w-4 h-4" />
            <span className="text-sm">£{basketTotal.toFixed(2)}</span>
            {basketCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-rose-500 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {basketCount}
              </span>
            )}
          </button>
        )}
      </div>
    </header>
  );
}
